import { cn } from '@/lib/utils';
import React from 'react';

interface OverviewCardProps {
  title: string;
  subtitle: React.ReactNode;
  value: string | number;
  icon?: React.ReactNode;
  className?: string;
}

/**
 * Overview metric card component
 * Displays a single metric with title, subtitle, and value
 * Uses Figma Token color variables
 */
const OverviewCard: React.FC<OverviewCardProps> = ({ title, subtitle, value, icon, className }) => {
  return (
    <div className={cn('flex flex-col gap-4 h-[76px]', className)}>
      <div className="flex items-start justify-between">
        <div className="flex flex-col gap-1">
          <span className="text-sm text-text-black font-semibold leading-4">{title}</span>
          <span className="text-xs text-text-main-body h-4 leading-4">{subtitle}</span>
        </div>
        {icon && (
          <div className="w-9 h-9 rounded-lg bg-solid-solid2 flex items-center justify-center">
            {icon}
          </div>
        )}
      </div>
      <div className="text-2xl leading-6 font-semibold text-text-black">{value}</div>
    </div>
  );
};

export default OverviewCard;
